import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LocalShipping } from '@material-ui/icons';
import { toast } from 'react-toastify';
import moment from 'moment';
import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';
import { get } from 'lodash';
import { ADM, GFE } from '~/constants/perfil';

import { UnidataTable } from '~/components';
import { number } from '~/helpers';
import { recordFiltering } from '~/store/modules/operacaonotafiscaldescargas/actions';

import NotaFiscalDescargasCancelamentoItem from './components/NotaFiscalDescargasCancelamentoItem';

function OperacaoNotaFiscalDescargasList() {
  const dispatch = useDispatch();

  const [
    habNotaFiscalDescargasCancelamentoItem,
    setHabNotaFiscalDescargasCancelamentoItem,
  ] = useState(false);

  const [itemSelecionado, setItemSelecionado] = React.useState({});

  const { profile } = useSelector((state) => state.user);

  const buttons = [];

  const operacaonotafiscaldescargas = useSelector(
    (state) => state.operacaonotafiscaldescargas
  );

  const refNotaFiscalDescargasCancelamentoItem = useRef(null);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.gloperfilid) {
        case ADM:
        case GFE:
          setHabNotaFiscalDescargasCancelamentoItem(true);
          break;
        default:
          setHabNotaFiscalDescargasCancelamentoItem(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(operacaonotafiscaldescargas.params));
  }, [operacaonotafiscaldescargas.params]);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'desc_nf',
        label: 'Nota Fiscal',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'desc_dt_emissao_nf',
        label: 'Data Emissão',
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'nfre_destinat_nome',
        label: 'Órgão/Entidade',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'desc_volume_nf',
        label: 'Quantidade',
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'nfre_produto_nome',
        label: 'Produto',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_descricao',
        label: 'Posto Recebedor',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'desc_status',
        label: 'Status',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nf_pode_cancelar',
        label: 'Permite Alterar',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prre_codigo',
        label: 'Recebimento Provisório',
        align: 'right',
      },
    ],
    []
  );

  const headerhabNotaFiscalDescargasCancelamentoItem = useMemo(
    () => [
      habNotaFiscalDescargasCancelamentoItem &&
        itemSelecionado.nf_pode_cancelar === 'SIM' &&
        buttons.push({
          title: 'Editar Status Nota Fiscal',
          action: (value) => handleNFAlterarClick(value),
          icon: <LocalShipping />,
        }),
    ],
    [
      habNotaFiscalDescargasCancelamentoItem,
      operacaonotafiscaldescargas,
      itemSelecionado,
    ]
  );

  //Valida se posso alterar o registro!!
  const handleNFAlterarClick = React.useCallback(
    (value) => {
      //function handleNFAlterarClick(value) {
      //console.log(value);
      const desc_status_atual_nf = get(value, 'nf_pode_cancelar', 'NAO');
      if (String(desc_status_atual_nf) === 'NAO') {
        toast.error('Nota Fiscal não pode ser alterada!');
        return;
      }
      return refNotaFiscalDescargasCancelamentoItem.current.handleToggleModal(
        value
      );
    },
    [refNotaFiscalDescargasCancelamentoItem]
  );

  const registroSelecionado = React.useCallback(
    (values) => {
      setItemSelecionado(values);
    },
    [operacaonotafiscaldescargas]
  );

  const filter = useMemo(
    () => [
      {
        id: 'desc_dt_emissao_nf',
        label: 'Data Emissão',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
    ],
    [datahorainicial]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="desc_dt_emissao_nf ASC"
        title={'Status Notas Fiscais'}
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        custom={filter}
        redux={operacaonotafiscaldescargas}
        read={recordFiltering}
        actions={habNotaFiscalDescargasCancelamentoItem ? buttons : undefined}
        detach="nfre_numero"
        keys="nfre_numero"
        onRow={(values) => registroSelecionado(values)}
        view="VW_NOTA_FICAL_RECEBIMENTO_GERAL"
        reportTitle="Status Notas Fiscais"
      />
      <NotaFiscalDescargasCancelamentoItem
        ref={refNotaFiscalDescargasCancelamentoItem}
        update={() => handleUpdate()}
        name="NotaFiscalDescargasCancelamentoItem"
      />
    </>
  );
}

export default OperacaoNotaFiscalDescargasList;
